module.exports = __webpack_public_path__ + "img/imposible-hangman-logo.91496aa2.png";